import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const SecondaryButton = styled(Button)(({ theme }) => ({
  borderRadius: '8px',
  border: `solid 1px ${theme.palette.primary.main}`,
  color: theme.palette.secondary.contrastText,
  width: '100%',
  height: '48px',
  fontSize: '16px',
  fontWeight: 600,
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
}));

export default SecondaryButton;
